<template>
  <div
    class="popup"
    :style="{
      background: `url('../images/popup-bg1.png')`,
    }"
  >
    <div class="popup-header">
      <span class="header-title" :title="data.name">{{ data.name }}</span>
    </div>

    <table class="popup-content">
      <tr v-for="item in items[type]" :key="item.name">
        <td style="text-align: left">{{ item.name }}</td>
        <td
          class="value"
          style="text-align: center"
          :style="{ color: item.color }"
          v-if="item.name === 'pH'"
        >
          {{ item.value.toFixed(2) }}
        </td>
        <td
          class="value"
          style="text-align: center"
          :style="{ color: item.alarm?'red':item.color }"
          v-else
        >
          {{ type === "dma" ? item.value : item.value.toFixed(3) }}
        </td>
        <td style="text-align: right">{{ item.unit }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "MarkerPopup",
  props: {
    type: String,
    data: Object | Array,
  },
  data() {
    return {
      items: {
        D01: [
          {
            name: "压力",
            value: "-",
            unit: "MPa",
            sensor: "A2",
            color: "#41FFDA",
          },
        ],
        D02: [
          {
            name: "流量",
            value: "-",
            unit: "m³/h",
            sensor: "A1",
            color: "#33CAFF",
          },
        ],
        D03: [
          {
            name: "压力",
            value: "-",
            unit: "MPa",
            sensor: "A2",
            color: "#41FFDA",
            alarm:false,
          },
          {
            name: "流量",
            value: "-",
            unit: "m³/h",
            sensor: "A1",
            color: "#33CAFF",
          },
        ],
        D04: [
          {
            name: "余氯",
            value: "-",
            unit: "mg/L",
            sensor: "A13",
            color: "#33CAFF",
          },
          {
            name: "浊度",
            value: "-",
            unit: "NTU",
            sensor: "A14",
            color: "#41FFDA",
          },
          { name: "pH", value: "-", unit: "", sensor: "A15", color: "#99AEFF" },
        ],
        factory: [
          {
            name: "余氯",
            value: "-",
            unit: "mg/L",
            sensor: "A13",
            color: "#33CAFF",
          },
          {
            name: "浊度",
            value: "-",
            unit: "NTU",
            sensor: "A14",
            color: "#41FFDA",
          },
          { name: "pH", value: "-", unit: "", sensor: "A15", color: "#99AEFF" },
        ],
        dma: [],
        pump: [
          {
            name: "流量",
            value: "-",
            unit: "m³/h",
            sensor: "A1",
            color: "#33CAFF",
          },
          {
            name: "压力",
            value: "-",
            unit: "MPa",
            sensor: "A6",
            color: "#41FFDA",
          },
        ],
      },
    };
  },
  methods: {},
  created() {
    if (this.type === "dma") {
      this.items["dma"] = this.data.sensors.map((item, index) => {
        return {
          name: item.name,
          value: item.o_realtime.value,
          unit: item.o_unit.unit,
          sensor: item.unit,
          color: index % 2 === 0 ? "#33CAFF" : "#41FFDA",
        };
      });
    }
    this.items[this.type].forEach((item) => {
      item.value =
        (this.data.sensors || []).find((i) => i.unit === item.sensor)
          ?.o_realtime.value || 0;
      item.alarm = (this.data.sensors || []).find((i) => i.unit === item.sensor)?.alarm
    });
  },
};
</script>

<style scoped lang="less">
.popup {
  display: flex;
  &-header {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 50px;

    .header-title {
      font-size: 18px;
      width: 90%;
      height: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &-content {
    display: flex;
    font-size: 16px;
    flex-direction: column;
    height: calc(100% - 100px);
    justify-content: space-evenly;
    align-items: center;

    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .value {
      color: #33caff;
      font-size: 18px;
    }
    td {
      padding: 10px;
    }
  }
}
</style>
